// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__10mYz","content":"styles_content__3hmfd","contentText":"styles_contentText__3jAGO","img":"styles_img__fyydT"};